import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';

const PurchaseReturnEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, token, logout, branchstate } = useAuth();
    const [itemOptions, setItemOptions] = useState([]);
    const branchId = 0;



    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState([]);

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    useEffect(() => {
        fetchInvoicetypeData();
        fetchfrightrate();
    }, []);

    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);

    const fetchfrightrate = () => {
        fetchData('CompanyApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    FreightGSTRate: data[0].FreightGSTRate,
                    PackingGSTRate: data[0].PackingGSTRate,
                }));
                setdefaultFreightGSTRate(data[0].FreightGSTRate);
                setdefaultPackingGSTRate(data[0].PackingGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
            });
    };

    //FOR GET InvoicetypeData  Details FROM API
    const fetchInvoicetypeData = () => {
        fetchData('PurchaseApi', `/InvoiceType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownInvoiceTypeOptions(data);

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillDate: formattedDate,
                    ClearingDate: formattedDate,
                    BranchId: branchId,
                    CompanyId: companyId,
                    CreatedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };


    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState(null);
    const [dropdownInvoiceTypeOptions, setDropdownInvoiceTypeOptions] = useState([]);
    const handleInputChange = (newValue) => newValue;

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 2) {
            return [];
        }


        try {
            const response = await fetchData('PurchaseApi', `/Party/${companyId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;

        const selectedItemId = selectedOption.value;
        const selectedSupplierRetail = supplierOptions.find((itemDetail) => itemDetail.Id === selectedItemId);
        const suppliergstno = selectedSupplierRetail?.GSTNumber ?? '';
        const supplieraddress1 = (selectedSupplierRetail?.AddressLine1 ?? '');
        const supplieraddress2 = (selectedSupplierRetail?.AddressLine2 ?? '');

        let invoiceTypeId = 2; // Default to B To C
        let gstNumber = '';

        if (!suppliergstno) {
            gstNumber = '';
            invoiceTypeId = 2;
        } else {
            const gstNumberPrefix = suppliergstno.substring(0, 2);
            if (gstNumberPrefix !== branchstate) {
                invoiceTypeId = 3; // IGST
                gstNumber = suppliergstno;
            } else {
                invoiceTypeId = 1; // B To B
                gstNumber = suppliergstno;
            }
        }

        setSelectedInvoiceType({
            value: invoiceTypeId,
            label: invoiceTypeId === 2 ? 'B To C' : invoiceTypeId === 3 ? 'IGST' : 'B To B',
        });

        setFormData((prevData) => ({
            ...prevData,
            InvoiceTypeId: invoiceTypeId,
            GSTNumber: gstNumber,
            CustomerAddress: supplieraddress1 + ' ' + supplieraddress2,
            CreatedBy: userId,
        }));
    };

    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;

    const calculateItemData = (item, formData) => {
        let rate = parseAndFix(item.Rate);
        let quantity = parseAndFix(item.Quantity);
        let cgstRate = parseAndFix(item.GSTRate) / 2;
        let sgstRate = parseAndFix(item.GSTRate) / 2;
        let Discper = parseAndFix(item.DiscountPercentage);
        let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
        let totdiscount = parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let amt = (quantity * rate).toFixed(2);
        let amount = (quantity * grate).toFixed(2);
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.InvoiceTypeId === 3) {
            igstAmount = ((amount * (cgstRate + sgstRate)) / 100).toFixed(2);
        } else {
            cgstAmount = ((amount * cgstRate) / 100).toFixed(2);
            sgstAmount = ((amount * sgstRate) / 100).toFixed(2);
        }



        let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
        let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
        setdefaultFreightGSTRate(defaultFreightGST);
        setdefaultPackingGSTRate(defaultPackingGST);

        const totalAmount = parseAndFix(amount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

        return {
            ...item,
            Amount: amt,
            DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
            TaxableAmount: amount,
            CGSTAmount: cgstAmount,
            SGSTAmount: sgstAmount,
            IGSTAmount: igstAmount,
            TotalAmount: totalAmount.toFixed(2),

        };
    };


    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

        let freightGSTRate = parseAndFix(formData.FreightGSTRate);
        let packingGSTRate = parseAndFix(formData.PackingGSTRate);
        freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
        packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));


        let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
        let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

        let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;
        let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: Quantity,
            Amount: Amount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            TotalAmount: grandTotal.toFixed(2),
            BalanceAmount: balhamt.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            FreightGSTAmount: freightGSTAmount,
            PackingGSTAmount: packingGSTAmount,
            ModifiedBy: userId,
            FreightGSTRate: freightGSTRate,
            PackingGSTRate: packingGSTRate,
        }));
    };

    // Calculation
    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        // Assuming invoicedeatils is a state setter function (e.g., setInvoicedeatils)
        setInvoicedeatils((prevDetails) => {

            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index], [name]: value };

            // Update the item in the copied array
            updatedDetails[index] = currentItem;

            const updatedItemData = updatedDetails.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.PaidAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );

            return updatedItemData;
        });
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        const updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));

        if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'PaidAmount', 'CardAmount', 'UPIAmount'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        // const fixedValue = parseAndFix(value).toFixed(2);
        const fixedValue = parseAndFix(value);

        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue  // the newly updated value
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = invoicedeatils.map((item) => calculateItemData(item, updatedFormData));
        setInvoicedeatils(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations               
        const TCSAmount = dynamicValue('TCSAmount');
        const FreightAmount = dynamicValue('FreightAmount');
        const PackingAmount = dynamicValue('PackingAmount');
        let CashAmount = dynamicValue('PaidAmount');
        let CardAmount = dynamicValue('CardAmount');
        let UPIAmount = dynamicValue('UPIAmount');
        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totals.DiscountAmount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            FreightAmount,
            PackingAmount,
            TCSAmount,
            CashAmount,
            CardAmount,
            UPIAmount,
        );
    };

    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };


    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = invoicedeatils.filter((_, i) => i !== itemToDeleteIndex);
            setInvoicedeatils(updatedItemList);
            const updatedItemData = updatedItemList.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.PaidAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );

            closeConfirmDialog();
        }
    };

    const [itemsOptions, setItemsrOptions] = useState([]);
    const handleItemChange = (newValue) => newValue;

    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }

        const customerid = formData.MasterId;
        try {
            // Fetch data from the API
            const response = await fetchData('PurchaseApi', `/Item/${companyId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemsrOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);

        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemsOptions.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            // const quantity = parseFloat(modalData.Quantity) || 0;
            const quantity = '1';
            const rate = parseFloat(selectedItemDetail.PurchaseRate.toFixed(2)) || 0;
            const cgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const sgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((amount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((amount * (sgstrate)) / 100).toFixed(2);
            }
            let gstamt = parseFloat((cgstamt + sgstamt + igstamt)).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);

            let defaultFreightGST = Math.max(defaultFreightGSTRate, gstrate);
            let defaultPackingGST = Math.max(defaultPackingGSTRate, gstrate);
            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData({
                ...modalData,
                Rate: rate, //selectedItemDetail.PurchaseRate.toFixed(2), // Assuming Rate is a number
                GSTRate: gstrate,
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemName1: selectedOption ? selectedItemDetail.ItemName1 : '',
                HSNCode: selectedOption ? selectedItemDetail.HSNCode : '',
                ItemId: selectedOption ? selectedOption.value : '',
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                Quantity: quantity,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemName1: selectedOption ? selectedItemDetail.ItemName1 : '',
                ItemId: selectedOption ? selectedOption.value : '',
                TaxableAmount: '0.00',
                CGSTAmount: '0.00',
                SGSTAmount: '0.00',
                IGSTAmount: '0.00',
                TotalAmount: '0.00',
                GSTAmt: '0.00',
                Quantity: '',
            });
        }
    };

    const handleModalInputChange = (event) => {
        const { name, value } = event.target;
        setModalData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'Quantity') {

            const quantity = parseFloat(value) || 0;
            const rate = parseFloat(modalData.Rate) || '';
            const cgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const sgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((amount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((amount * (sgstrate)) / 100).toFixed(2);
            }
            let gstamt = (parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);

            let defaultFreightGST = Math.max(defaultFreightGSTRate, modalData.GSTRate);
            let defaultPackingGST = Math.max(defaultPackingGSTRate, modalData.GSTRate);
            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData({
                ...modalData,
                // Rate: rate.toFixed(2),
                Rate: rate,
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
            });
        }
        else if (name === 'Rate') {
            const quantity = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(value) || 0;
            const cgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const sgstrate = parseFloat(modalData.GSTRate / 2) || 0;
            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((amount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((amount * (sgstrate)) / 100).toFixed(2);
            }
            let gstamt = (parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);

            let defaultFreightGST = Math.max(defaultFreightGSTRate, modalData.GSTRate);
            let defaultPackingGST = Math.max(defaultPackingGSTRate, modalData.GSTRate);
            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData({
                ...modalData,
                Rate: rate,//rate.toFixed(2), // Assuming Rate is a number    
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
            });
        }
    };

    //// modalData 
    // FOR MODEL DATA (Invoice Details)
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemName1: '',
        ItemId: '',
        Quantity: '',
        Rate: '',
        Amount: '',
        TaxableAmount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
        BalanceStock: '0',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemName1: '',
            ItemId: '',
            Quantity: '',
            Rate: '',
            Amount: '',
            GSTRate: '',
            GSTAmount: '',
            TotalAmount: '',
            BalanceStock: '0',
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.MasterId) {
            setErrorMessage('Supplier is required !');
            setIsLoading(false);
            return;
        }
        if (!formData.BillNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }
        if (!formData.Remarks) {
            setErrorMessage(' Remarks is required !');
            setIsLoading(false);
            return;
        }

        // Cash amount validation
        if (formData.BalanceAmount < 0) {
            setErrorMessage('Blance Amount less than 0 is not allowed!');
            setIsLoading(false);
            return;
        }

        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,

        }));

        const CreateData = {
            Purchase: formData,
            PurchaseDetails: invoicedeatils
        };

        // Validate form data here if needed

        //postData('PurchaseReturnApi', CreateData, token)
        updateData('PurchaseReturnApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/PurchaseReturnIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    useEffect(() => {
        fetchData('PurchaseReturnApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    //setFormData(response.response_data.Purchase);
                    setInvoicedeatils(response.response_data.PurchaseDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                    setFormData(response.response_data.Purchase);
                }
            })
            .catch((error) => {
                console.error('Error fetching Purchase Details:', error);
            });
    }, [id]);

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = invoicedeatils.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '100%', marginTop: '10px' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Purchase Return - Edit</h6>

                    <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '-5px' }}>
                        <div className="mr-4">
                            <input
                                className="shadow text-gray-700 leading-tight"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                onFocus={() => setIsFocused(true)}
                                onBlur={() => setIsFocused(false)}
                                style={{
                                    width: isFocused ? '200px' : '170px',
                                    height: '30px',
                                    border: '1px solid #ccc',
                                    borderRadius: '15px',
                                    padding: '0 20px',
                                    transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                    outline: 'none',
                                    borderColor: isFocused ? 'darkcyan' : '#ccc',
                                    boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                }}
                            />
                        </div>

                        <div className="mr-4">
                            <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="billDate" style={{ fontSize: '12px' }}>
                                Total Item Count :
                                <span style={{ color: '#F2613F', fontSize: '14px', marginLeft: '4px' }}>
                                    {invoicedeatils.length}
                                </span>
                            </label>
                        </div>

                        <div>
                            <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="totalQuantity" style={{ fontSize: '12px' }}>
                                Total QTY :
                                <span style={{ color: 'green', fontSize: '14px', marginLeft: '4px' }}>
                                    {formData.TotalQuantity}
                                </span>
                            </label>
                        </div>
                    </div>
                    <Button

                        style={{
                            background: 'linear-gradient(to right,rgb(94, 179, 138),rgb(98, 150, 61))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',

                        }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <span>Update</span>}
                    </Button>

                    <Button

                        component={Link}
                        to="/PurchaseReturnIndex"
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgb(162, 31, 31),rgb(223, 91, 70))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',

                        }}
                    >
                        Cancel
                    </Button>

                </div>

                <div className="w-full flex flex-wrap" style={{ padding: '7px', borderRadius: '10px', marginTop: '-5px' }}>

                    <div className="w-full pr-4" style={{ marginTop: '-0.15%' }}>
                        <div className="w-full mb-2 flex">

                            <div className="w-4/5 mr-2" style={{ marginTop: '-5px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                    Supplier Name
                                    <span className="text-red-500">*</span>
                                    <span style={{ marginLeft: '10%', color: 'black' }}> Invoice Type : </span> <span style={{ color: 'black', fontSize: '14px', fontWeight: 'bolder' }}>{formData.InvoiceTypeName}</span>

                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.SupplierName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Supplier"
                                    name='Supplier'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                    Bill Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formatDateForInput(formData.BillDate)}
                                    onChange={handleChange}
                                    type="date"
                                    name='BillDate'

                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                    Bill No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    // value={`${formData.BillPrefix || ''}/${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                    value={formData.BillNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Bill Number"
                                    disabled
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.Amount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Amount"
                                    style={{ textAlign: 'right' }}
                                    name='Amount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Discount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.DiscountAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Discount"
                                    style={{ textAlign: 'right' }}
                                    name='DiscountAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Taxable Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TaxableAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="TaxableAmount"
                                    style={{ textAlign: 'right' }}
                                    name='TaxableAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    CGST
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CGST Amount"
                                    style={{ textAlign: 'right' }}
                                    name='CGSTAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    SGST
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.SGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="SGST Amount"
                                    style={{ textAlign: 'right' }}
                                    name='SGST Amount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    IGST
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.IGSTAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="IGST Amount"
                                    style={{ textAlign: 'right' }}
                                    name='IGSTAmount'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    TCS
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TCSAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="TCS Amount"
                                    style={{ textAlign: 'right' }}
                                    name='TCSAmount'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Freight <span style={{ color: 'darkmagenta' }}>({formData.FreightGSTRate}%)</span> <span style={{ color: 'red' }}>{formData.FreightGSTAmount}</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.FreightAmount || 0}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="FreightAmount"
                                    style={{ textAlign: 'right' }}
                                    name='FreightAmount'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Packing  <span style={{ color: 'darkmagenta' }}> ({formData.PackingGSTRate}%)</span> <span style={{ color: 'red' }}>{formData.PackingGSTAmount}</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.PackingAmount || 0}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="PackingAmount"
                                    style={{ textAlign: 'right' }}
                                    name='PackingAmount'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Round Off
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.RoundOff}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="RoundOff"
                                    style={{ textAlign: 'right' }}
                                    name='RoundOff'
                                    readOnly
                                />
                            </div>
                        </div>

                        <div className="w-full mb-4 flex">
                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Remarks
                                    {/* <span className="text-red-500">*</span> */}
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.Remarks}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Remarks"
                                    name='Remarks'
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TotalAmount}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Total Amount"
                                    name='TotalAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>


                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Paid Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.PaidAmount}
                                    onChange={handleChange}
                                    type="number"
                                    placeholder="Paid Amount"
                                    name='PaidAmount'
                                    style={{ textAlign: 'right' }}
                                    max={formData.TotalAmount}
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Balance Amount
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.BalanceAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="BalanceAmount"
                                    name='BalanceAmount'
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                />
                            </div>

                        </div>


                        {/* Purchase Order Table */}
                        <div className="w-full mb-2" style={{ marginTop: '-0.95%', overflow: 'auto' }}>
                            <table
                                className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                                style={{
                                    borderCollapse: 'collapse',
                                    border: '1px solid #ddd',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    background: 'linear-gradient(135deg, #F3F7FF, #FFFFFF)',
                                }}
                            >
                                <thead
                                    style={{
                                        // backgroundColor: '#102E50',
                                        backgroundColor: '#003A6B',
                                        color: '#FFFFFF',
                                        textAlign: 'left',
                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                    }}
                                >
                                    <tr>
                                        <th
                                            style={{
                                                fontSize: '13px',
                                                padding: '4px',
                                                borderBottom: '2px solid #E0E0E0',
                                                textAlign: 'left',
                                                color: 'white'
                                            }}
                                        >
                                            SL.No
                                        </th>
                                        {[
                                            'ITEM',
                                            'QTY',
                                            'R.QTY',
                                            'RATE',
                                            'AMOUNT',
                                            'DIS %',
                                            'DIS ₹',
                                            'TAXABLE',
                                            'GST ₹',
                                            'TOTAL',
                                        ].map((header) => (
                                            <th
                                                key={header}
                                                style={{
                                                    fontSize: '12px',
                                                    padding: '4px',
                                                    borderBottom: '2px solid #E0E0E0',
                                                    textAlign: header === 'ITEM' ? 'left' : 'right',
                                                    color: 'white'
                                                }}
                                            >
                                                {header}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredData.map((item, index) => {
                                        const balStock = parseFloat(item.SaleQuantity);
                                        const quantity = !item.PrevPurchasedQuantity
                                            ? parseFloat(item.Quantity)
                                            : parseFloat(item.PrevPurchasedQuantity - item.Quantity);

                                        // Conditional background color: Light red if BalStock <= QuantityForOne
                                        const rowColor = (balStock <= quantity) ? '#ffcccc' : 'transparent';

                                        return (
                                            <tr key={index} className="border-b"
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                                    borderBottom: '1px solid #E0E0E0',
                                                    transition: 'transform 0.2s ease-in-out',
                                                    cursor: 'pointer',
                                                    color: 'black'
                                                }}
                                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                            >

                                                <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '75px' }}>
                                                    {index + 1}
                                                </td>
                                                <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '220px' }}>{item.ItemName}</td>

                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        type="number"
                                                        value={item.SaledQuantity}
                                                        className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D3F1DF', textAlign: 'right' }}
                                                        min="0"
                                                        aria-label={`Order quantity for item ${item.Id}`}
                                                        name="SaledQuantity"
                                                        onChange={(e) => handleCalculation(e, index, 'SaledQuantity')}
                                                        disabled
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '60px' }}>
                                                    <input
                                                        type="number"
                                                        value={item.Quantity}
                                                        className="w-full px-2 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#F6D6D6', textAlign: 'right' }}
                                                        min="0"
                                                        aria-label={`Order quantity for item ${item.Id}`}
                                                        name='Quantity'
                                                        onChange={(e) => {
                                                            const newValue = parseInt(e.target.value, 10);

                                                            // Calculate allowed max based on PrevSaleQuantity
                                                            const allowedMax = (!item.PrevPurchasedQuantity || item.PrevPurchasedQuantity === 0)
                                                                ? item.SaledQuantity
                                                                : item.SaledQuantity + item.PrevPurchasedQuantity;

                                                            if (!isNaN(newValue) && newValue <= allowedMax) {
                                                                handleCalculation(e, index, 'Quantity');
                                                            }
                                                        }}
                                                        max={
                                                            !item.PrevPurchasedQuantity || item.PrevPurchasedQuantity === 0
                                                                ? item.SaledQuantity
                                                                : item.SaledQuantity + item.PrevPurchasedQuantity
                                                        }
                                                        onClick={(e) => e.target.select()}
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.Rate || 0}
                                                        onChange={(e) => handleCalculation(e, index, 'Rate')}
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#DFF2EB', textAlign: 'right' }}
                                                        type="number"
                                                        name="Rate"
                                                        onClick={(e) => e.target.select()}
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.Amount || 0}
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                        name="Amount"
                                                        readOnly
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.DiscountPercentage || 0}
                                                        onChange={(e) => handleCalculation(e, index, 'DiscountPercentage')}
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#E9EED9', textAlign: 'right' }}
                                                        type="number"
                                                        name="DiscountPercentage"
                                                        min="0"
                                                        onClick={(e) => e.target.select()}
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.DiscountAmount || 0}
                                                        readOnly
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.TaxableAmount || 0}
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                        readOnly
                                                    />
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '80px' }}>
                                                    <input
                                                        value={parseFloat(item.CGSTAmount) + parseFloat(item.SGSTAmount) + parseFloat(item.IGSTAmount)}
                                                        className="px-1 py-1 border rounded-md"
                                                        style={{
                                                            fontSize: '13px',
                                                            fontWeight: 'bold',
                                                            textAlign: 'right',
                                                            width: '70%', // Adjust the width to fit
                                                        }}
                                                        readOnly
                                                    />
                                                    <span style={{ marginLeft: '3px', color: 'darkmagenta', fontSize: '11px', fontWeight: 'bold', }}>
                                                        {item.GSTRate ? parseFloat(item.GSTRate).toString() : 0}%
                                                    </span>
                                                </td>
                                                <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                                    <input
                                                        value={item.TotalAmount || 0}
                                                        readOnly
                                                        className="w-full px-1 py-1 border rounded-md"
                                                        style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#EDDFE0', textAlign: 'right' }}
                                                    />
                                                </td>

                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

            </div>
        </Fragment>
    );
};

export default PurchaseReturnEdit;
